import { render, staticRenderFns } from "./DateComp.vue?vue&type=template&id=212b2084&scoped=true&"
import script from "./DateComp.vue?vue&type=script&lang=js&"
export * from "./DateComp.vue?vue&type=script&lang=js&"
import style0 from "./DateComp.vue?vue&type=style&index=0&id=212b2084&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "212b2084",
  null
  
)

export default component.exports